
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image, Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika kommt im Herbst auf einem klassischen Familienbetrieb im Kanton St. Gallen auf die Welt und wiegt 39 Kilogramm. Die Schweizer Milchbauern halten im Durchschnitt 25 Kühe in ihrem Betrieb.`}</p>
    <Image file={[require('images/rinderprobetrieb-01.svg'), require('images/rinderprobetrieb-02.svg')]} title='Anzahl Milchkühe pro Betrieb' subtitle='Durchschnitt 2018' source='Quelle: www.swissmilk.ch' mdxType="Image" />
    <p>{`Neben Erika werden am selben Tag schweizweit 1850 weitere Kälber geboren – und fast gleich viele Rinder, Kühe und Kälber geschlachtet (1725).`}</p>
    <Image file={require('images/geburtenschlachtungen.svg')} title='Geburten und Schlachtungen an einem Tag' subtitle='Täglicher Durchschnitt 2018' source='Quelle: www.identitas.ch' mdxType="Image" />
Erika wird in den ersten 24 Stunden nach der Geburt von der Mutter getrennt – dies wäre auch auf einem Biohof so. 
Dieses Verfahren wird gewählt, um zu verhindern, dass sich eine natürliche Beziehung zwischen Mutter und Kalb entwickeln kann –
eine späte Trennung wäre schwieriger (<Link url='https://www.quarks.de/umwelt/tierwelt/so-stresst-die-fruehe-trennung-kalb-und-kuh/' mdxType="Link">mehr dazu</Link>). 
Zudem: Je länger das Kalb am Euter hängt, desto weniger Milch bleibt für den Verkauf. Die Alternative Mutterkuhhaltung macht in der Schweiz mit 14 Prozent nach wie vor einen kleinen Anteil des Rindviehbestandes aus (<Link url='https://www.mutterkuh.ch/de/mutterkuh-schweiz/mutterkuhhaltung' mdxType="Link">mehr dazu</Link>).
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;